<template>
  <div class="faq-lists">
    <div class="faq-list" v-for="(list, listId) in multiListDesc" :key="listId">
      <p class="title" v-html="list.title"></p>
      <!-- Lvl 0 -->
      <ol class="list list-bold-marker" v-bind:type="list.type">
        <li v-for="(en, enId) in list.list" :key="enId">
          <span v-html="en.text"></span>
          <!-- Lvl 1 -->
          <ol class="list list-bold-marker my-2" v-if="en.list" v-bind:type="en.type" v-bind:style="en.style">
            <li v-for="(enLv1, enIdLv1) in en.list" :key="enIdLv1">
              <span v-html="enLv1.text"></span>
              <!-- Lvl 2 -->
              <ol class="list list-bold-marker my-3" v-if="enLv1.list" v-bind:type="enLv1.type" v-bind:style="enLv1.style">
                <li v-for="(enLv2, enIdLv2) in enLv1.list" :key="enIdLv2">
                  <span v-html="enLv2.text"></span>
                  <!-- Lvl 3 -->
                  <ol class="list list-bold-marker my-3" v-if="enLv2.list" v-bind:type="enLv2.type" v-bind:style="enLv2.style">
                    <li v-for="(enLv3, enIdLv3) in enLv2.list" :key="enIdLv3">
                      <span v-html="enLv3.text"></span>
                      <!-- Lvl 4 -->
                      <ol class="list list-bold-marker my-3" v-if="enLv3.list" v-bind:type="enLv3.type" v-bind:style="enLv3.style">
                        <li v-for="(enLv4, enIdLv4) in enLv3.list" :key="enIdLv4">
                          <span v-html="enLv4.text"></span>
                        </li>
                      </ol>
                      <!-- /Lvl 4 -->
                    </li>
                  </ol>
                  <!-- /Lvl 3 -->
                </li>
              </ol>
              <!-- /Lvl 2 -->
            </li>
          </ol>
          <!-- /Lvl1 -->
        </li>
      </ol>
      <!-- /Lvl0 -->
    </div>
  </div>
</template>
<script>

export default {
  name: 'NestedListDescription',
  props: {
    multiListDesc: Array,
  },
};
</script>
